/* eslint-disable import/prefer-default-export */
export const installationSummaryModal = 'installationSummaryModal';
export const installationOnlyModal = 'installationOnlyModal';
export const installationOnlyModalTitle = 'Installation Only';
export const mandiEditAttributesModal = 'mandiEditAttributesModal';
export const mandiEditAttributesModalTitle = 'Editing';
export const copyStylesModal = 'copyStylesModal';
export const confirmDeleteAttributeModal = 'confirmDeleteAttributeModal';

